// Upload Image action constants
export const DO_IMPORT_CUSTOMER = 'DO_IMPORT_CUSTOMER'
export const SHOW_MODAL_IMPORT = 'SHOW_MODAL_IMPORT'
export const HIDE_MODAL_IMPORT = 'HIDE_MODAL_IMPORT'
export const SHOW_MODAL_ERROR_IMPORT = 'SHOW_MODAL_ERROR_IMPORT'
export const HIDE_MODAL_ERROR_IMPORT = 'HIDE_MODAL_ERROR_IMPORT'
export const SET_IMPORTING_STATUS = 'SET_IMPORTING_STATUS'
export const DO_IMPORT_ITEM = 'DO_IMPORT_ITEM'



// WEBPACK FOOTER //
// ./app/actions/uploaders/constants.js